import { shallowEqual, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { tr } from 'mmfintech-commons'

import { Button } from 'mmfintech-portal-commons'
import { BackIcon } from '@icons'

import WarningIcon from '@assets/icons/warning-blue.svg'
import ExclamationIcon from '@assets/icons/exclamation.svg'

import './bankTransferWarning2.scss'

interface BankTransferWarning2Props {
  handleBack: () => void
  handleNext: () => void
  paymentMethod?: string
  onCancel?: () => void
}

export const BankTransferWarning2 = ({
  handleBack,
  handleNext,
  paymentMethod,
  onCancel
}: BankTransferWarning2Props) => {
  const { checkoutPayFetching } = useSelector(
    ({ checkout: { checkoutPayFetching } }) => ({
      checkoutPayFetching
    }),
    shallowEqual
  )

  return (
    <div className='bank-transfer-warning2'>
      <div className='back-button-wrapper'>
        <span onClick={handleBack} data-test='back-button'>
          <BackIcon />
          <span>{tr('FRONTEND.BUTTONS.BACK', 'Back')}</span>
        </span>
      </div>

      <div className='payment-method-wrapper' data-test={`pay-with-${paymentMethod}-warning2`}>
        {tr('CHECKOUT.PAYMENT.PAY_BY', 'Pay by {{METHOD}}', {
          METHOD: paymentMethod ? tr(`METADATA.PAYMENT_OPTIONS.${paymentMethod}`, paymentMethod) : ''
        })}
      </div>

      <div className='warning-container'>
        <img src={ExclamationIcon} width={90} height={90} alt='' />

        <div className='warning-title'>
          {tr('CHECKOUT.MANUAL.STEP2.TITLE', 'Are you sending from your own account?')}
        </div>
        <div className='warning-content'>
          <img src={WarningIcon} alt='' />
          <span>
            {tr(
              'CHECKOUT.MANUAL.STEP2.WARNING',
              'Only you can pay for this transfer. We will reject the transfer if the funds are sent by someone else'
            )}
          </span>
        </div>
      </div>

      <div className='warning-buttons'>
        <Button
          type='button'
          color='primary'
          text={tr('CHECKOUT.MANUAL.STEP2.CONTINUE_BUTTON', 'Continue')}
          onClick={handleNext}
          loading={checkoutPayFetching}
          data-test='button-confirm'
        />
        {typeof onCancel === 'function' && (
          <div className='cancel-button-container mt-2'>
            <Link to='#' onClick={onCancel} data-test='cancel-button'>
              {tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}
